// extracted by mini-css-extract-plugin
export default {"icon":"LinkCreator_icon__uUmow","active":"LinkCreator_active__zKG3p","scroll":"LinkCreator_scroll__t1eD5"};